<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="章节">
                  <el-input  v-model="queryForm.charpterId"></el-input>
              </el-form-item>
<!--              <el-form-item label="播放次数">-->
<!--                  <el-input  v-model="queryForm.playTimes"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="应学习人数">-->
<!--                  <el-input  v-model="queryForm.shoudStudyStudent"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="已学习人数">-->
<!--                  <el-input  v-model="queryForm.haveStudyStudent"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="已完成学习人数">-->
<!--                  <el-input  v-model="queryForm.finishStudyStudent"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseCharpterStudentrecordList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addEduCourseCharpterStudentrecord"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editEduCourseCharpterStudentrecord(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseCharpterStudentrecord(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
<!--        <span-->
<!--          title="搜索"-->
<!--          class="icon-box"-->
<!--          @click="search"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <Search />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseCharpterStudentrecordList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseCharpterStudentrecordList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="charpterName"
        label="章节"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studentrecord.playTimes"
        label="播放次数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studentrecord.shoudStudyStudent"
        label="应学习人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studentrecord.haveStudyStudent"
        label="已学习人数"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studentrecord.finishStudyStudent"
        label="已完成学习人数"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="studentrecord.createTime"-->
<!--        label="创建时间"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduCourseCharpterStudentrecord(scop.row.studentrecord.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editEduCourseCharpterStudentrecord(scop.row.studentrecord.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteEduCourseCharpterStudentrecord(scop.row.studentrecord.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseCharpterStudentrecordStates[eduCourseCharpterStudentrecordState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseCharpterStudentrecord"
          ref="eduCourseCharpterStudentrecordForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="章节"
            prop="charpterId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseCharpterStudentrecord.charpterId"-->
<!--              :disabled="eduCourseCharpterStudentrecordState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="eduCourseCharpterStudentrecord.charpterId"
                  placeholder="请选择"
                  :disabled="eduCourseCharpterStudentrecordState == 'check'"
                  size="small"
              >
                  <el-tree
                      :data="eduCourseCharpterStudentrecordList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="播放次数"
            prop="playTimes"
          >
            <el-input
              size="small"
              v-model="eduCourseCharpterStudentrecord.playTimes"
              :disabled="eduCourseCharpterStudentrecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="应学习人数"
            prop="shoudStudyStudent"
          >
            <el-input
              size="small"
              v-model="eduCourseCharpterStudentrecord.shoudStudyStudent"
              :disabled="eduCourseCharpterStudentrecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="已学习人数"
            prop="haveStudyStudent"
          >
            <el-input
              size="small"
              v-model="eduCourseCharpterStudentrecord.haveStudyStudent"
              :disabled="eduCourseCharpterStudentrecordState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="已完成学习人数"
            prop="finishStudyStudent"
          >
            <el-input
              size="small"
              v-model="eduCourseCharpterStudentrecord.finishStudyStudent"
              :disabled="eduCourseCharpterStudentrecordState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseCharpterStudentrecordState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseCharpterStudentrecordList();
                    this.getEduCourseCharpterStudentrecordList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseCharpterStudentrecordList();
                    this.getEduCourseCharpterStudentrecordList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     charpterId: '', //章节
                     playTimes: '', //播放次数
                     shoudStudyStudent: '', //应学习人数
                     haveStudyStudent: '', //已学习人数
                     finishStudyStudent: '', //已完成学习人数
                },
                treeProps: {
                    children: 'children',
                    label: 'charpterName'
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseCharpterStudentrecordState: 'add',
                eduCourseCharpterStudentrecordStates: {
                    add: '添加进度',
                    check: '查看进度',
                    edit: '修改进度'
                },

                multipleSelection: [],
                eduCourseCharpterStudentrecordList: [],
                eduCourseCharpterStudentrecord: {
                    id: '', //
                    charpterId: '', //章节
                    playTimes: '', //播放次数
                    shoudStudyStudent: '', //应学习人数
                    haveStudyStudent: '', //已学习人数
                    finishStudyStudent: '', //已完成学习人数
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    charpterId: [{ required: true, message: '章节不能为空', trigger: 'blur' }],
                    playTimes: [{ required: true, message: '播放次数不能为空', trigger: 'blur' }],
                    shoudStudyStudent: [{ required: true, message: '应学习人数不能为空', trigger: 'blur' }],
                    haveStudyStudent: [{ required: true, message: '已学习人数不能为空', trigger: 'blur' }],
                    finishStudyStudent: [{ required: true, message: '已完成学习人数不能为空', trigger: 'blur' }],
                },
                courseId: ''
            };
        },
        created() {
            // this.getEduCourseCharpterStudentrecordList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id){
                this.courseId = id;
                this.getEduCourseCharpterStudentrecordList();
            },
            resetEduCourseCharpterStudentrecordList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseCharpterStudentrecordList = [];
            },
            resetDialog() {
                this.eduCourseCharpterStudentrecordState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //
                      charpterId: '', //章节
                      playTimes: '', //播放次数
                      shoudStudyStudent: '', //应学习人数
                      haveStudyStudent: '', //已学习人数
                      finishStudyStudent: '', //已完成学习人数
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                };
                this.getEduCourseCharpterStudentrecordList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseCharpterStudentrecord = {
                      id: '', //
                      charpterId: '', //章节
                      playTimes: '', //播放次数
                      shoudStudyStudent: '', //应学习人数
                      haveStudyStudent: '', //已学习人数
                      finishStudyStudent: '', //已完成学习人数
                      createUserId: '', //
                      createTime: '', //
                      updateUserId: '', //
                      updateTime: '', //
                      deleteFlag: '', //
                };
            },
            submitForm() {
                if (this.eduCourseCharpterStudentrecordState == 'add') {
                    this.$refs.eduCourseCharpterStudentrecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharpterstudentrecord/add`,{ ...this.eduCourseCharpterStudentrecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseCharpterStudentrecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseCharpterStudentrecordState == 'edit') {
                    this.$refs.eduCourseCharpterStudentrecordForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursecharpterstudentrecord/edit`,{ ...this.eduCourseCharpterStudentrecord }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseCharpterStudentrecordList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseCharpterStudentrecord() {
                this.showDialog = true;
                this.eduCourseCharpterStudentrecordState = 'add';
            },
            checkEduCourseCharpterStudentrecord(eduCourseCharpterStudentrecordId) {
                console.log(eduCourseCharpterStudentrecordId);
                this.currentEduCourseCharpterStudentrecordId = eduCourseCharpterStudentrecordId;

                this.getEduCourseCharpterStudentrecordById();
                this.showDialog = true;
                this.eduCourseCharpterStudentrecordState = 'check';
            },
            editEduCourseCharpterStudentrecord(eduCourseCharpterStudentrecordId) {
                console.log('eduCourseCharpterStudentrecord', eduCourseCharpterStudentrecordId);
                if (eduCourseCharpterStudentrecordId) {
                    this.currentEduCourseCharpterStudentrecordId = eduCourseCharpterStudentrecordId;
                    this.getEduCourseCharpterStudentrecordById();
                } else {
                    this.eduCourseCharpterStudentrecord = { ...this.eduCourseCharpterStudentrecord, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseCharpterStudentrecordState = 'edit';
            },
            deleteEduCourseCharpterStudentrecord(eduCourseCharpterStudentrecordId) {
                let ids = '';
                if (eduCourseCharpterStudentrecordId) {
                    ids = eduCourseCharpterStudentrecordId;
                } else {
                    ids = this.multipleSelection.map((eduCourseCharpterStudentrecord) => eduCourseCharpterStudentrecord.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursecharpterstudentrecord/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseCharpterStudentrecordList();
                                this.getEduCourseCharpterStudentrecordList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseCharpterStudentrecordList() {
                this.resetEduCourseCharpterStudentrecordList();
                this.getEduCourseCharpterStudentrecordList();
            },
            getEduCourseCharpterStudentrecordList(query = {}) {
                this.loading = true;
                get(`/edu/coursecharpter/findAllAsTree`,{  ...this.queryForm, courseId: this.courseId }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseCharpterStudentrecordList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseCharpterStudentrecordById() {
                get(`/edu/coursecharpterstudentrecord/get`,{ id: this.currentEduCourseCharpterStudentrecordId }).then((res) =>{
                    if(res.success){
                      this.eduCourseCharpterStudentrecord = { ...this.eduCourseCharpterStudentrecord, ...res.eduCourseCharpterStudentrecord };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseCharpterStudentrecordList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursecharpterstudentrecord/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursecharpterstudentrecord/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursecharpterstudentrecord/importData`,formData);
              this.refreshEduCourseCharpterStudentrecordList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseCharpterStudentrecordList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseCharpterStudentrecordList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>